import api from './client';

export const productsApi = {
  list:          (params?: any) => api.get('/products', { params }),
  create:        (data: any)    => api.post('/products', data),
  categories:    ()             => api.get('/products/categories'),
  createCategory:(data: any)    => api.post('/products/categories', data),
  units:         ()             => api.get('/products/units'),
  createUnit:    (data: any)    => api.post('/products/units', data),
};
